import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  AdminUpdateBuyerListPermissionsMutation,
  AdminUpdateBuyerListPermissionsMutationVariables,
  UpdateBuyerListPermissionsInput,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const adminUpdateBuyerListPermissionsMutation = graphql(`
  mutation adminUpdateBuyerListPermissions($input: UpdateBuyerListPermissionsInput!) {
    adminUpdateBuyerListPermissions(input: $input) {
      objectId
      accessorId
      accessorType
      roleName
    }
  }
`);

type UpdatePermissionsParams = {
  buyerListGuid: string;
  updates: UpdateBuyerListPermissionsInput["updates"];
};

export function useAdminUpdateBuyerListPermissions(
  options?: UseMutationOptions<
    AdminUpdateBuyerListPermissionsMutation,
    unknown,
    AdminUpdateBuyerListPermissionsMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { mutate: innerMutate, ...rest } = useGraphQlMutation(
    adminUpdateBuyerListPermissionsMutation,
    {
      ...options,
      onSuccess: (data, variables, context) => {
        void queryClient.invalidateQueries(["buyerLists"]);
        void queryClient.invalidateQueries(["buyerList", variables.input.id]);
        options?.onSuccess?.(data, variables, context);
      },
    },
  );
  return {
    ...rest,
    mutate: ({ buyerListGuid, updates }: UpdatePermissionsParams) =>
      innerMutate({ input: { id: buyerListGuid, updates } }),
  };
}
